<template>
    <v-card color="grey lighten-4" elevation="0" class="px-12 py-8" v-if="!$vuetify.breakpoint.mobile">
        <v-card-title class="tit tit--sm primary--text">
            교환 내역
            <v-spacer />
            <v-btn small color="primary" style="border-radius:8px!important" @click="excel">엑셀 다운로드</v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table v-bind="{ headers, items, itemsPerPage: -1 }" disable-filtering disable-sort hide-default-footer class="exchange-table">
                <template #footer>
                    <v-layout justify-end align-baseline class="pa-2" style="gap:12px">
                        <span> 성공: {{ success.format() }}개 </span>
                        <span> 실패: {{ failure.format() }}개 </span>
                        <v-btn x-small text to="/mypage/exchange">
                            내역보기
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-layout>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <v-layout v-else column>
        <v-card color="grey lighten-4" elevation="0">
            <v-card-title class="tit tit--sm primary--text justify-center">
                교환권 번호
            </v-card-title>
            <v-card-text>
                <v-row class="row--small">
                    <template v-for="item in items">
                        <v-col cols="12" :key="item.tempId">
                            <v-sheet height="40px" class="d-flex justify-center align-center">
                                {{ item.prev || "-" }}
                            </v-sheet>
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
        <v-sheet class="d-flex justify-center py-4">
            <v-icon x-large color="primary">mdi-chevron-double-down</v-icon>
        </v-sheet>
        <v-card color="grey lighten-4" elevation="0">
            <v-card-title class="tit tit--sm primary--text justify-center">
                나누리 핀번호
            </v-card-title>
            <v-card-text>
                <v-row class="row--small">
                    <template v-for="item in items">
                        <v-col cols="12" :key="item.tempId">
                            <v-sheet height="40px" class="d-flex justify-center align-center">
                                {{ item.next || "-" }}
                            </v-sheet>
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
        <v-sheet class="py-4">
            <v-layout align-baseline>
                <v-layout class="px-4" style="gap:12px">
                    <span> 성공: {{ success.format() }}개 </span>
                    <span> 실패: {{ failure.format() }}개 </span>
                </v-layout>
                <v-spacer />
                <v-btn x-small text to="/mypage/exchange">
                    내역보기
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-layout>
        </v-sheet>
    </v-layout>
</template>

<script>
const headers = [
    {
        text: "교환권 번호",
        value: "prev",
        align: "center",
    },
    {
        text: "나누리핀 번호",
        value: "next",
        align: "center",
    },
];

export default {
    props: {
        value: {
            /** @type {import('vue').PropType<import('@/assets/lib').UserExchange[]>} */
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        headers,
    }),
    computed: {
        /** @type {import('vue/types').ComputedOptions<import('@/assets/lib').UserExchange[]>} */
        items() {
            return [...this.value];
        },
        success() {
            return this.items.reduce((count, { done, fail }) => (done && !fail ? count + 1 : count), 0);
        },
        failure() {
            return this.items.reduce((count, { done, fail }) => (done && fail ? count + 1 : count), 0);
        },
    },
    methods: {
        excel() {
            this.$excel(this.items, headers, `상품권교환목록`)
        },
    },
};
</script>

<style lang="scss" scoped>
.exchange-table {
    background: transparent !important;

    ::v-deep {
        * {
            background: transparent !important;
            border: 1px solid transparent !important;
            border-collapse: separate;
        }
        table {
            border-spacing: 8px !important;
        }
        thead {
            position: relative;

            &::after {
                content: "";
                position: absolute;
                bottom: 7px;
                left: 0;
                width: 100%;
                height: 1px;
                border-bottom: 1px solid grey;
            }
        }
        td {
            background: white !important;
        }
    }
}
</style>
